<template>

            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
      
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">首次认证</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                        
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box">
                                                <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">注意事项</b></h4>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000 !important;">
                                                    1.请确保您提交材料中的所有信息真实、准确。<br/>
                                                    2.特许私人财富管理师认证标准指导委员会重视申请人的诚信问题，会对申请材料的真实性进行调查，包括但不限于自行或委托第三方进行背景调查。<br/>
                                                    3.提交申请后，申请表中内容将无法进行修改。<br/>
                                                    4."特许私人财富管理师（CPWM<sup>&#174;</sup>）" 持证人将成为CPWM® 协会会员。会员费2年300元，首次认证免交会员费。<br/>

                                                </p>
                                                <h4 class="m-t-0 header-title" style="font-size: 15px;"><b>第一步：完善个人信息</b></h4>
                                                <div class="row">
      
                                                      <div class="col-md-6" >
                                                            <div class="card-box" style="padding:5px 20px 20px 20px;">
                                                                  <div class="tab-content" style="padding-top: 0px;">
                                                                        <div class="tab-pane fade show active" id="home">
                                                                              <!--start-->
                              
                              
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">姓名（中文）</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="hename"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">姓（拼音）</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="surname_en"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">名（拼音）</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="name_en"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">性别</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="sex"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">证件类型</p>
                                                                                    <select class="form-control" v-model="codetype" style="height: 38px;">
                                                                                          <option value="居民身份证">居民身份证</option>
                                                                                          <option value="中国护照">中国护照</option>
                                                                                          <option value="外国护照">外国护照</option>
                                                                                          <option value="香港永久性居民身份证">香港永久性居民身份证</option>
                                                                                          <option value="台湾身份证">台湾身份证</option>
                                                                                          <option value="澳门特别行政区永久性居民身份证">澳门特别行政区永久性居民身份证</option>
                                                                                          <option value="港澳居民来往内地通行证">港澳居民来往内地通行证</option>
                                                                                          <option value="台湾居民来往大陆通行证">台湾居民来往大陆通行证</option>
                                                                                    </select>
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">证件号码</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="code"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">手机号</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="tel"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">邮箱</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="email"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">工作单位（总公司）</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="Headquarters"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">工作单位（分公司）</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="BranchOffice"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">工作部门</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="WorkDepartment"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div class="inputself">
                                                                                    <p class="mb-1 mt-4 font-weight-bold">工作职务</p>
                                                                                    <input type="text" name="country"
                                                                                           v-model="Jobduties"
                                                                                           class="form-control">
                                                                              </div>
                                                                              <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                                                    <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="edit">下一步</button>
                                                                              </div>
                                                                              <div style="clear: both"></div>
                                                                              <!--over-->
                                                                        </div>
                                                                       
                  
                                                                  </div>
                                                            </div>
                                                      </div>
                                          
                                                </div>
                                                <!-- end row -->
                                    
                                          </div> <!-- end card-box -->
                                    </div><!-- end col -->
                              </div>
                              <!-- end row -->
                          
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
      
                  <!--footer-->
      
            </div>
            
          


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                        tel: this.tel,
                        email:this.email,
                        lisname:this.lisname,

                        surname: this.surname,
                        name: this.name,
                        surname_en: this.surname_en,
                        name_en: this.name_en,
                        sex: this.sex,
                        Headquarters: this.Headquarters,
                        BranchOffice: this.BranchOffice,
                        WorkDepartment: this.WorkDepartment,
                        Jobduties: this.Jobduties,
                        address: this.address,
                        
                        
                        hename:this.hename,
                        codetype:this.codetype,
                        code:this.code,
                        
                  }
            },
            mounted(){
                  this.showmember();
                  
            },
            methods: {
                  showmember: function () {
                        //console.log(this.identity);
                        let data = {
                              tel: this.tel
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.tel=response.data.user.tel;
                              this.email=response.data.user.email;
                              this.lisname=response.data.user.name;

                              this.surname=response.data.information.surname;
                              this.name=response.data.information.name;
                              this.surname_en=response.data.information.surname_en;
                              this.name_en=response.data.information.name_en;
                              this.sex=response.data.information.sex;
                              this.Headquarters=response.data.information.Headquarters;
                              this.BranchOffice=response.data.information.BranchOffice;
                              this.WorkDepartment=response.data.information.WorkDepartment;
                              this.Jobduties=response.data.information.Jobduties;
                              this.address=response.data.information.address;
                              
                              this.code=response.data.information.code;
                              this.codetype=response.data.information.codetype;
                              
                              //显示字符串拼接
                              this.hename=this.surname+this.name;
                              


                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  edit:function () {
                        if(!this.hename || !this.surname_en || !this.name_en || !this.sex || !this.codetype || !this.code || !this.tel || !this.email || !this.Headquarters || !this.BranchOffice || !this.WorkDepartment || !this.Jobduties){
                              swal(
                                    {
                                          title: '请补充完善个人资料',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              return false;
                        }
                        let data = {
                              tel: this.tel,

                              surname: this.surname,
                              name: this.name,
                              surname_en: this.surname_en,
                              name_en: this.name_en,
                              sex: this.sex,
                              Headquarters: this.Headquarters,
                              BranchOffice: this.BranchOffice,
                              WorkDepartment: this.WorkDepartment,
                              Jobduties: this.Jobduties,
                              address: this.address,
                              code:this.code,
                              codetype:this.codetype,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/member_edit',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                    
                                    window.location.href="/member2/#/Authentication_step2";
                              }else{
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                        }.bind(this)).catch(function OnError() {

                        })
                  },
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}
      .inputself{width:49%;margin-right:1%;float: left}
  
     
</style>



// WEBPACK FOOTER //
// src/components/Authentication_step1.vue